var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { attrs: { id: "contents" } }, [
    _c(
      "div",
      { staticClass: "contents_wrap" },
      [
        _c(
          "fragment",
          [
            _c("skp-breadcrumbs", {
              on: {
                "page-title": function(val) {
                  return (_vm.pageTitle = val)
                }
              }
            })
          ],
          1
        ),
        _vm._v(" "),
        _c("h2", { staticClass: "pg_title" }, [_vm._v(_vm._s(_vm.pageTitle))]),
        _vm._v(" "),
        _c("div", { staticClass: "create_wrap" }, [
          _c("table", { staticClass: "create_table" }, [
            _vm._m(0),
            _vm._v(" "),
            _c("caption", [
              _c("em", { staticClass: "txt_mandatory" }, [_vm._v("*")]),
              _vm._v(
                "\n                    " +
                  _vm._s(_vm.$t("FIELD.GLOBAL.MANDATORY")) +
                  "\n                "
              )
            ]),
            _vm._v(" "),
            _c("tr", [
              _c("th", [
                _vm._v(
                  "\n                        " +
                    _vm._s(_vm.$t("FIELD.GLOBAL.INQUIRY")) +
                    "\n                        "
                ),
                _c("em", { staticClass: "txt_mandatory" }, [_vm._v("*")])
              ]),
              _vm._v(" "),
              _c("td", [
                _c("fieldset", { staticClass: "ui_fieldset set_3" }, [
                  _c("div", [
                    _c(
                      "select",
                      {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.inquiry1Code,
                            expression: "inquiry1Code"
                          }
                        ],
                        staticClass: "slt_white w100p",
                        attrs: {
                          disabled:
                            !_vm.isNull(_vm.faq_id) &&
                            _vm.isNull(_vm.inquiry2Code)
                        },
                        on: {
                          change: [
                            function($event) {
                              var $$selectedVal = Array.prototype.filter
                                .call($event.target.options, function(o) {
                                  return o.selected
                                })
                                .map(function(o) {
                                  var val = "_value" in o ? o._value : o.value
                                  return val
                                })
                              _vm.inquiry1Code = $event.target.multiple
                                ? $$selectedVal
                                : $$selectedVal[0]
                            },
                            function($event) {
                              return _vm.inquiryList(2)
                            }
                          ]
                        }
                      },
                      [
                        _c("option", { attrs: { value: "" } }, [
                          _vm._v(_vm._s(_vm.$t("FIELD.FAST.DURATION.ALL")))
                        ]),
                        _vm._v(" "),
                        _vm._l(_vm.inquiry1CodeList, function(item) {
                          return _c(
                            "option",
                            {
                              key: _vm.pageName + item.CD,
                              domProps: { value: item.CD }
                            },
                            [_vm._v(_vm._s(item.CD_NAME))]
                          )
                        })
                      ],
                      2
                    )
                  ]),
                  _vm._v(" "),
                  _c("div", [
                    _c(
                      "select",
                      {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.inquiry2Code,
                            expression: "inquiry2Code"
                          }
                        ],
                        staticClass: "slt_white w100p",
                        attrs: {
                          disabled:
                            !_vm.isNull(_vm.faq_id) &&
                            _vm.isNull(_vm.inquiry2Code)
                        },
                        on: {
                          change: function($event) {
                            var $$selectedVal = Array.prototype.filter
                              .call($event.target.options, function(o) {
                                return o.selected
                              })
                              .map(function(o) {
                                var val = "_value" in o ? o._value : o.value
                                return val
                              })
                            _vm.inquiry2Code = $event.target.multiple
                              ? $$selectedVal
                              : $$selectedVal[0]
                          }
                        }
                      },
                      [
                        _c("option", { attrs: { value: "" } }, [
                          _vm._v(_vm._s(_vm.$t("FIELD.FAST.DURATION.ALL")))
                        ]),
                        _vm._v(" "),
                        _vm._l(_vm.inquiry2CodeList, function(item) {
                          return _c(
                            "option",
                            {
                              key: _vm.pageName + item.CD,
                              domProps: { value: item.CD }
                            },
                            [_vm._v(_vm._s(item.CD_NAME))]
                          )
                        })
                      ],
                      2
                    )
                  ])
                ])
              ])
            ]),
            _vm._v(" "),
            _c("tr", [
              _c("th", [
                _vm._v(
                  "\n                        " +
                    _vm._s(_vm.$t("FIELD.FAST.ADVANCED.MODEL")) +
                    "\n                        "
                ),
                _c("em", { staticClass: "txt_mandatory" }, [_vm._v("*")])
              ]),
              _vm._v(" "),
              _c("td", [
                _c("fieldset", { staticClass: "ui_fieldset" }, [
                  _c("label", { staticClass: "serach-wrap" }, [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.modelNm,
                          expression: "modelNm"
                        }
                      ],
                      staticClass: "text_input cur_pointer",
                      attrs: {
                        type: "text",
                        placeholder: _vm.$t("BUTTON.GLOBAL.SEARCH"),
                        readonly: ""
                      },
                      domProps: { value: _vm.modelNm },
                      on: {
                        click: function($event) {
                          return _vm.searchModelPopup()
                        },
                        input: function($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.modelNm = $event.target.value
                        }
                      }
                    }),
                    _vm._v(" "),
                    _vm._m(1)
                  ]),
                  _vm._v(" "),
                  _c("label", { staticClass: "checkbox-wrap" }, [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.modelCheck,
                          expression: "modelCheck"
                        }
                      ],
                      attrs: { type: "checkbox", checked: "" },
                      domProps: {
                        checked: Array.isArray(_vm.modelCheck)
                          ? _vm._i(_vm.modelCheck, null) > -1
                          : _vm.modelCheck
                      },
                      on: {
                        click: function($event) {
                          return _vm.clearModel()
                        },
                        change: function($event) {
                          var $$a = _vm.modelCheck,
                            $$el = $event.target,
                            $$c = $$el.checked ? true : false
                          if (Array.isArray($$a)) {
                            var $$v = null,
                              $$i = _vm._i($$a, $$v)
                            if ($$el.checked) {
                              $$i < 0 && (_vm.modelCheck = $$a.concat([$$v]))
                            } else {
                              $$i > -1 &&
                                (_vm.modelCheck = $$a
                                  .slice(0, $$i)
                                  .concat($$a.slice($$i + 1)))
                            }
                          } else {
                            _vm.modelCheck = $$c
                          }
                        }
                      }
                    }),
                    _vm._v(" "),
                    _c("i", { staticClass: "check-icon" }),
                    _vm._v(" "),
                    _c("em", [_vm._v(_vm._s(_vm.$t("FIELD.FAQ.NOT.RELEVANT")))])
                  ])
                ])
              ])
            ]),
            _vm._v(" "),
            _c("tr", [
              _c("th", [
                _vm._v(
                  "\n                        " +
                    _vm._s(_vm.$t("FIELD.GLOBAL.CATEGORY")) +
                    "\n                        "
                ),
                _c("em", { staticClass: "txt_mandatory" }, [_vm._v("*")])
              ]),
              _vm._v(" "),
              _c("td", [
                _c("fieldset", { staticClass: "ui_fieldset set_3" }, [
                  _c("label", { staticClass: "select-wrap" }, [
                    _c(
                      "select",
                      {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.category1Code,
                            expression: "category1Code"
                          }
                        ],
                        staticClass: "slt_white w100p",
                        attrs: {
                          id: "category1Code",
                          disabled: !_vm.modelCheck
                        },
                        on: {
                          change: [
                            function($event) {
                              var $$selectedVal = Array.prototype.filter
                                .call($event.target.options, function(o) {
                                  return o.selected
                                })
                                .map(function(o) {
                                  var val = "_value" in o ? o._value : o.value
                                  return val
                                })
                              _vm.category1Code = $event.target.multiple
                                ? $$selectedVal
                                : $$selectedVal[0]
                            },
                            function($event) {
                              return _vm.categoryList(2)
                            }
                          ]
                        }
                      },
                      _vm._l(_vm.category1CodeList, function(item) {
                        return _c(
                          "option",
                          {
                            key: _vm.pageName + item.code,
                            domProps: { value: item.code }
                          },
                          [_vm._v(_vm._s(item.codeName))]
                        )
                      }),
                      0
                    )
                  ]),
                  _vm._v(" "),
                  _c("label", { staticClass: "select-wrap" }, [
                    _c(
                      "select",
                      {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.category2Code,
                            expression: "category2Code"
                          }
                        ],
                        staticClass: "slt_white w100p",
                        attrs: {
                          id: "category2Code",
                          disabled: !_vm.modelCheck
                        },
                        on: {
                          change: [
                            function($event) {
                              var $$selectedVal = Array.prototype.filter
                                .call($event.target.options, function(o) {
                                  return o.selected
                                })
                                .map(function(o) {
                                  var val = "_value" in o ? o._value : o.value
                                  return val
                                })
                              _vm.category2Code = $event.target.multiple
                                ? $$selectedVal
                                : $$selectedVal[0]
                            },
                            function($event) {
                              return _vm.categoryList(3)
                            }
                          ]
                        }
                      },
                      _vm._l(_vm.category2CodeList, function(item) {
                        return _c(
                          "option",
                          {
                            key: _vm.pageName + item.code,
                            domProps: { value: item.code }
                          },
                          [_vm._v(_vm._s(item.codeName))]
                        )
                      }),
                      0
                    )
                  ]),
                  _vm._v(" "),
                  _c("label", { staticClass: "select-wrap" }, [
                    _c(
                      "select",
                      {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.category3Code,
                            expression: "category3Code"
                          }
                        ],
                        staticClass: "slt_white w100p",
                        attrs: {
                          id: "category3Code",
                          disabled: !_vm.modelCheck
                        },
                        on: {
                          change: function($event) {
                            var $$selectedVal = Array.prototype.filter
                              .call($event.target.options, function(o) {
                                return o.selected
                              })
                              .map(function(o) {
                                var val = "_value" in o ? o._value : o.value
                                return val
                              })
                            _vm.category3Code = $event.target.multiple
                              ? $$selectedVal
                              : $$selectedVal[0]
                          }
                        }
                      },
                      _vm._l(_vm.category3CodeList, function(item) {
                        return _c(
                          "option",
                          {
                            key: _vm.pageName + item.code,
                            domProps: { value: item.code }
                          },
                          [_vm._v(_vm._s(item.codeName))]
                        )
                      }),
                      0
                    )
                  ])
                ])
              ])
            ]),
            _vm._v(" "),
            "C550" === _vm.corpCd || "WA" === _vm.corpCd
              ? _c("tr", [
                  _c("th", [
                    _vm._v(
                      "\n                        " +
                        _vm._s(_vm.$t("FIELD.GLOBAL.SEARCHKEYWORD")) +
                        "\n                        "
                    ),
                    _c("em", { staticClass: "txt_mandatory" }, [_vm._v("*")])
                  ]),
                  _vm._v(" "),
                  _c("td", [
                    _c("span", { staticClass: "clearable" }, [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.searchKeyword,
                            expression: "searchKeyword"
                          },
                          { name: "clearable", rawName: "v-clearable" }
                        ],
                        staticClass: "text_input w100p",
                        attrs: { type: "text" },
                        domProps: { value: _vm.searchKeyword },
                        on: {
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.searchKeyword = $event.target.value
                          }
                        }
                      })
                    ])
                  ])
                ])
              : _vm._e(),
            _vm._v(" "),
            _c("tr", [
              _c("th", [
                _vm._v(
                  "\n                        " +
                    _vm._s(_vm.$t("FIELD.GLOBAL.IMPORTANT")) +
                    "\n                        "
                ),
                _c("em", { staticClass: "ico_info" }, [
                  _c("i", { staticClass: "tooltip" }, [
                    _vm._v(_vm._s(_vm.$t("FIELD.GLOBAL.ETC.058")))
                  ])
                ])
              ]),
              _vm._v(" "),
              _c("td", [
                _c("label", { staticClass: "checkbox-wrap" }, [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.gradeCode,
                        expression: "gradeCode"
                      }
                    ],
                    attrs: {
                      type: "checkbox",
                      "true-value": "S",
                      "false-value": ""
                    },
                    domProps: {
                      checked: Array.isArray(_vm.gradeCode)
                        ? _vm._i(_vm.gradeCode, null) > -1
                        : _vm._q(_vm.gradeCode, "S")
                    },
                    on: {
                      change: function($event) {
                        var $$a = _vm.gradeCode,
                          $$el = $event.target,
                          $$c = $$el.checked ? "S" : ""
                        if (Array.isArray($$a)) {
                          var $$v = null,
                            $$i = _vm._i($$a, $$v)
                          if ($$el.checked) {
                            $$i < 0 && (_vm.gradeCode = $$a.concat([$$v]))
                          } else {
                            $$i > -1 &&
                              (_vm.gradeCode = $$a
                                .slice(0, $$i)
                                .concat($$a.slice($$i + 1)))
                          }
                        } else {
                          _vm.gradeCode = $$c
                        }
                      }
                    }
                  }),
                  _vm._v(" "),
                  _c("i", { staticClass: "check-icon" }),
                  _vm._v(" "),
                  _c("em", [_vm._v(_vm._s(_vm.$t("FIELD.GLOBAL.IMPORTANT")))])
                ])
              ])
            ]),
            _vm._v(" "),
            _c("tr", [
              _c("th", [
                _vm._v(
                  "\n                        " +
                    _vm._s(_vm.$t("FIELD.GLOBAL.TITLE")) +
                    "\n                        "
                ),
                _c("em", { staticClass: "txt_mandatory" }, [_vm._v("*")])
              ]),
              _vm._v(" "),
              _c("td", [
                _c("span", { staticClass: "clearable" }, [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.title,
                        expression: "title"
                      },
                      { name: "clearable", rawName: "v-clearable" }
                    ],
                    staticClass: "text_input w100p",
                    attrs: { type: "text" },
                    domProps: { value: _vm.title },
                    on: {
                      input: function($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.title = $event.target.value
                      }
                    }
                  })
                ])
              ])
            ]),
            _vm._v(" "),
            _c("tr", [
              _c("th", [
                _vm._v(
                  "\n                        " +
                    _vm._s(_vm.$t("FIELD.GLOBAL.QNA.DESC")) +
                    "\n                        "
                ),
                _c("em", { staticClass: "txt_mandatory" }, [_vm._v("*")]),
                _vm._v(" "),
                "solutionDesc" === _vm.openNamo
                  ? _c(
                      "a",
                      {
                        staticClass: "ico_write_global",
                        attrs: { href: "javascript:" },
                        on: {
                          click: function($event) {
                            return _vm.openNamoClick("questionDesc")
                          }
                        }
                      },
                      [_c("span", { staticClass: "sr_only" })]
                    )
                  : _vm._e()
              ]),
              _vm._v(" "),
              _c(
                "td",
                [
                  "questionDesc" === _vm.openNamo
                    ? _c("cross-editor", {
                        attrs: {
                          editorId: "questionDesc",
                          editorData: _vm.questionDesc
                        }
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  "solutionDesc" === _vm.openNamo
                    ? _c("div", {
                        staticClass: "namoClass",
                        domProps: { innerHTML: _vm._s(_vm.questionDesc) }
                      })
                    : _vm._e()
                ],
                1
              )
            ]),
            _vm._v(" "),
            _c("tr", [
              _c("th", [
                _vm._v(
                  "\n                        " +
                    _vm._s(_vm.$t("FIELD.GLOBAL.ANS.DESC")) +
                    "\n                        "
                ),
                _c("em", { staticClass: "txt_mandatory" }, [_vm._v("*")]),
                _vm._v(" "),
                "questionDesc" === _vm.openNamo
                  ? _c(
                      "a",
                      {
                        staticClass: "ico_write_global",
                        attrs: { href: "javascript:" },
                        on: {
                          click: function($event) {
                            return _vm.openNamoClick("solutionDesc")
                          }
                        }
                      },
                      [_c("span", { staticClass: "sr_only" })]
                    )
                  : _vm._e()
              ]),
              _vm._v(" "),
              _c(
                "td",
                [
                  "solutionDesc" === _vm.openNamo
                    ? _c("cross-editor", {
                        attrs: {
                          editorId: "solutionDesc",
                          editorData: _vm.solutionDesc
                        }
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  "questionDesc" === _vm.openNamo
                    ? _c("div", {
                        staticClass: "namoClass",
                        domProps: { innerHTML: _vm._s(_vm.solutionDesc) }
                      })
                    : _vm._e()
                ],
                1
              )
            ]),
            _vm._v(" "),
            _c("tr", [
              _c("th", [_vm._v(_vm._s(_vm.$t("FIELD.GLOBAL.ATTACHMENT")))]),
              _vm._v(" "),
              _c(
                "td",
                { staticClass: "no_padding" },
                [
                  _c("innorix-upload", {
                    attrs: {
                      uploadId: _vm.pageName,
                      id: _vm.pageName,
                      name: _vm.pageName,
                      serviceType: _vm.serviceType,
                      onlyUpload: _vm.onlyUpload,
                      attachList: _vm.attach
                    },
                    on: { files: _vm.setFiles }
                  })
                ],
                1
              )
            ])
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "btn_wrap_full topLine" }, [
          _vm.faq_id
            ? _c(
                "a",
                {
                  staticClass: "btn_white size_full",
                  attrs: { href: "javascript:" },
                  on: {
                    click: function($event) {
                      return _vm.pageMove(_vm.$route.name)
                    }
                  }
                },
                [_vm._v("List")]
              )
            : _vm._e(),
          _vm._v(" "),
          "" === _vm.faq_id || "Y" === _vm.params.creationYn
            ? _c("div", { staticClass: "btn_right" }, [
                _vm.faq_id
                  ? _c(
                      "a",
                      {
                        staticClass: "btn_white",
                        attrs: { href: "javascript:" },
                        on: {
                          click: function($event) {
                            return _vm.faqDel()
                          }
                        }
                      },
                      [_vm._v(_vm._s(_vm.$t("BUTTON.GLOBAL.DELETE")))]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _c(
                  "a",
                  {
                    staticClass: "btn_blue",
                    attrs: { href: "javascript:" },
                    on: {
                      click: function($event) {
                        return _vm.save(0)
                      }
                    }
                  },
                  [_vm._v(_vm._s(_vm.$t("BUTTON.GLOBAL.REGISTER")))]
                )
              ])
            : _vm._e()
        ])
      ],
      1
    )
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("colgroup", [
      _c("col", { attrs: { width: "154" } }),
      _vm._v(" "),
      _c("col", { attrs: { width: "*" } })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("a", { staticClass: "in_btn_search" }, [
      _c("i", { staticClass: "ico_input_serach" }),
      _vm._v(" "),
      _c("span", { staticClass: "sr_only" })
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-e416fc48", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e416fc48","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/skpComponents/view/basis/faq/createNewFAQ.vue
// module id = VUzz
// module chunks = 0